import { defineMessages } from '@atlassian/jira-intl'; // TODO - Port i18n string translations to new module ID keys

const messages: {
	infoText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reloadIssue: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	infoTextIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	reloadIssueIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	infoText: {
		id: 'issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text',
		defaultMessage: "We couldn't load this issue.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	reloadIssue: {
		id: 'issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue',
		defaultMessage: 'Reload issue',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	infoTextIssueTermRefresh: {
		id: 'issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.info-text-issue-term-refresh',
		defaultMessage: "We couldn't load this work item.",
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
	reloadIssueIssueTermRefresh: {
		id: 'issue-navigator.navigator.content.issue-list.issue-card-skeleton.error-info.reload-issue-issue-term-refresh',
		defaultMessage: 'Reload work item',
		// eslint-disable-next-line @atlassian/i18n/require-description
		description: '',
	},
});
export default messages;
